import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavBar } from 'antd-mobile';
import { getNavBarContainerStyle } from '../../../utils/deviceUtils';
import { DeliveringPath } from '../../../enums/DeliveryNavigatePathEnum';
import { t } from '../../../i18n';
import AccessInfoDetailView from './components/AccessInfoDetailView';
import { setShouldCheckPendingCodes } from './utils/accessCodeValidationState';
import {WEB_TEMPORARY_GRAY_ENABLED} from '../../../utils/grayscaleDriverUtils';

const AccessInfoDetailPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const address = location.state?.displayAddress ?? location.state?.address;
    const addressId = location.state?.addressId;
    const trackingNumber = location.state?.trackingNumber;
    const addressLat = location.state?.addressLat as number | undefined;
    const addressLon = location.state?.addressLon as number | undefined;
    const orderId = location.state?.orderId as number | undefined; // 订单ID（用于创建门禁码）
    const fromMapMode = location.state?.fromMapMode as boolean | undefined; // 是否来自地图模式
    const skipDistanceLimit = location.state?.skipDistanceLimit as boolean | undefined;

    const handleBack = () => {
        setShouldCheckPendingCodes(true);
        // 如果来自地图模式，返回时导航到地图模式页面，而不是运单详情页
        if (fromMapMode) {
            // 设置标记，让地图模式页面恢复弹窗状态
            sessionStorage.setItem('returningFromDetail', 'true');

            const webTempGrayEnabled = localStorage.getItem(WEB_TEMPORARY_GRAY_ENABLED);

            if (webTempGrayEnabled) {
                // 灰度模式，跳转到临时地图页面
                navigate("/delivery/temporary/map-mode", { replace: false });
            } else {
                // 正常模式，跳转到正式地图页面
                navigate(DeliveringPath.DELIVERY_MAP_MODE, { replace: false });
            }
        } else {
            navigate(-1);
        }
    };

    if (!orderId) {
        return (
            <div className="flex flex-col h-screen bg-gray-50">
                <div {...getNavBarContainerStyle()}>
                    <NavBar onBack={handleBack}>
                        {t('pages.delivery.orderDetail.referenceAccessInfo')}
                    </NavBar>
                </div>
                <div className="flex-1 flex items-center justify-center">
                    <div className="text-gray-500">
                        {t('pages.delivery.orderDetail.noAccessInfo')}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-screen bg-gray-50">
            {/* Navbar */}
            <div {...getNavBarContainerStyle()}>
                <NavBar onBack={handleBack}>
                    {t('pages.delivery.orderDetail.referenceAccessInfo')}
                </NavBar>
            </div>

            {/* Content */}
            <AccessInfoDetailView
                orderId={orderId}
                addressId={addressId}
                trackingNumber={trackingNumber}
                address={address}
                addressLat={addressLat}
                addressLon={addressLon}
                onBack={handleBack}
                skipDistanceLimit={skipDistanceLimit}
            />
        </div>
    );
};

export default AccessInfoDetailPage;
